// extracted by mini-css-extract-plugin
export var banner = "_cy-0";
export var closeButton = "_cy-2";
export var greenCheckmark = "_cy-3";
export var hereLink = "_cy-4";
export var titleIcon = "_cy-1";